import React from 'react';
import { BsGithub, BsInstagram } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://github.com/GerdaElize" target="_blank" rel="noreferrer noopener"><BsGithub /></a>
      
    </div>
    <div>
      <a href="https://www.facebook.com/gerda.kasselman" target="_blank" rel="noreferrer noopener"><FaFacebookF /></a>
    </div>
    <div>
      <a href="https://www.instagram.com/gerdakasselman/" target="_blank" rel="noreferrer noopener"><BsInstagram /></a>
      
    </div>
  </div>
);

export default SocialMedia;